<template>
  <div class="login">
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="px-8 py-4">
            <h3 class="title">Datos del Perfil</h3>
            <form ref="form">
              <v-text-field
                v-model="name"
                :error-messages="nameErrors"
                label="Nombre"
                id="nametext"
                required
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
              ></v-text-field>

              <v-switch v-model="changePassword" label="Cambiar contraseña" />

              <div v-if="changePassword">
                <v-text-field
                  v-model="password"
                  :error-messages="passwordErrors"
                  :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword1 ? 'text' : 'password'"
                  id="password"
                  name="password"
                  label="Contraseña actual"
                  required
                  @click:append="showPassword1 = !showPassword1"
                  @input="$v.password.$touch()"
                  @blur="$v.password.$touch()"
                ></v-text-field>

                <v-text-field
                  v-model="newPassword"
                  :error-messages="newPasswordErrors"
                  :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword2 ? 'text' : 'password'"
                  id="newPassword"
                  name="newPassword"
                  label="Nueva contraseña"
                  required
                  @click:append="showPassword2 = !showPassword2"
                  @input="$v.newPassword.$touch()"
                  @blur="$v.newPassword.$touch()"
                ></v-text-field>

                <v-text-field
                  v-model="repeatPassword"
                  :error-messages="repeatPasswordErrors"
                  :append-icon="showPassword3 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword3 ? 'text' : 'password'"
                  id="repeatPasswordtext"
                  name="repeatPasswordtext"
                  label="Escribe de nuevo la contraseña"
                  required
                  @click:append="showPassword3 = !showPassword3"
                  @input="$v.repeatPassword.$touch()"
                  @blur="$v.repeatPassword.$touch()"
                  v-on:keyup.enter="enterPressed"
                ></v-text-field>
              </div>

              <p v-if="error" class="error-2">
                No fue posible realizar la actualización.
              </p>
              <p v-if="error404" class="error-2">
                Has introducido incorrectamente la contraseña actual.
              </p>

              <p>&nbsp;</p>

              <v-btn class="mr-4" @click="submit"> Guardar </v-btn>
              <v-btn @click="clear"> Limpiar </v-btn>

              <p>&nbsp;</p>
            </form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// :rules="[rules.required, rules.min]"
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";

import { mapMutations, mapState } from "vuex";
import auth from "../auth";
import api from "../api";

export default {
  mixins: [validationMixin],

  validations: {
    name: { required, minLength: minLength(4) },
    password: {
      required: requiredIf(function () {
        return this.changePassword;
      }),
      minLength: minLength(6),
    },
    newPassword: {
      required: requiredIf(function () {
        return this.changePassword;
      }),
      minLength: minLength(6),
    },
    repeatPassword: {
      required: requiredIf(function () {
        return this.changePassword;
      }),
      sameAsPassword: sameAs("newPassword"),
    },
  },

  data: () => ({
    name: "",
    password: "",
    newPassword: "",
    repeatPassword: "",
    error: false,
    error404: false,
    showPassword1: false,
    showPassword2: false,
    showPassword3: false,
    changePassword: false,
  }),

  computed: {
    ...mapState(["isLogged", "loggedUser", "pageTitle"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required &&
        errors.push("El correo electrónico es obligatorio.");
      !this.$v.name.minLength &&
        errors.push("El nombre debe tener al menos 4 caracteres.");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
        errors.push("La contraseña es obligatoria.");
      !this.$v.password.minLength &&
        errors.push("La contraseña debe tener al menos 6 caracteres.");
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.newPassword.$dirty) return errors;
      !this.$v.newPassword.required &&
        errors.push("La contraseña es obligatoria.");
      !this.$v.newPassword.minLength &&
        errors.push("La contraseña debe tener al menos 6 caracteres.");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword &&
        errors.push("Las contraseñas deben coincidir.");
      return errors;
    },
  },

  methods: {
    ...mapMutations(["updateLogged"]),

    enterPressed() {
      this.submit();
    },

    submit() {
      this.$v.$touch();
      if (!this.$v.$anyError) this.update();
    },

    clear() {
      this.$v.$reset();
      this.name = "";
      this.password = "";
      this.repeatPassword = "";
    },

    async update() {
      let user = {
        email: this.loggedUser.email,
        token: this.loggedUser.token,
        name: this.name,
      };
      if (this.changePassword) {
        user = {
          ...user,
          password: this.password,
          newPassword: this.newPassword,
        };
      }
      try {
        const response = await api.updateUser(user);
        if (response.data.status == 200) {
          user = {
            name: this.name,
            email: this.loggedUser.email,
            level: this.loggedUser.level,
            avatar: this.loggedUser.avatar,
            token: response.data.token,
          };
          auth.setUserLogged(user);
          this.updateLogged(user);
          this.$router.push("/");
        } else {
          if (response.data.status == 404) {
            this.error404 = true;
          } else this.error = true;
          this.password = "";
          password.focus();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  async mounted() {
    let user = await auth.getUserLogged();
    this.updateLogged(user);
    this.name = this.loggedUser.name;
    nametext.focus();
  },
};
</script>

<style scoped>
.login {
  padding: 2rem;
}
.title {
  text-align: center;
}
.form {
  margin: 3rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 20%;
  min-width: 350px;
  max-width: 100%;
  background: rgba(19, 35, 47, 0.9);
  border-radius: 5px;
  padding: 40px;
  box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.3);
}
.form-label {
  margin-top: 2rem;
  color: white;
  margin-bottom: 0.5rem;
}
.form-label:first-of-type {
  margin-top: 0rem;
}
.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid white;
  color: white;
}
.form-input:focus {
  outline: 0;
  border-color: #1ab188;
}
.form-submit {
  background: #1ab188;
  border: none;
  color: white;
  margin-top: 3rem;
  padding: 1rem 0;
  cursor: pointer;
  transition: background 0.2s;
}
.form-submit:hover {
  background: #0b9185;
}
.error {
  margin: 1rem 0 0;
  color: #ffffff;
  background: red;
  padding: 0.5em 0em;
}
.error-2 {
  margin: 1rem 0 0;
  color: #ff5252;
  background: white;
  padding: 0.5em 0em;
}
.container {
  max-width: 700px;
}
</style>